import React from "react";
import { Link as MuiLink } from "@mui/material";
import { Link } from "react-router";
import { Trans, useTranslation } from "react-i18next";
import { Banner } from "@components";

type RequestError = Partial<ApiException> & { status: number };

interface Props {
  error?: RequestError | null;
}

export const LoginErrorBanner = ({ error }: Props) => {
  const { t } = useTranslation();

  if (!error) return null;

  const errorStatusCode = error?.status;

  if (errorStatusCode === 401 || errorStatusCode === 403) {
    return (
      <Banner
        type="error"
        data-testid="login-failed-message"
        displayDefaultIcon
        text={
          <Trans
            i18nKey="loginPage.form.requestErrors.loginFailed"
            components={{
              passwordRestoreLink: (
                <MuiLink
                  component={Link}
                  to="/reset/password"
                  underline="hover"
                />
              ),
            }}
          />
        }
      ></Banner>
    );
  }

  return (
    <Banner
      type="error"
      displayDefaultIcon
      data-testid="login-something-wrong-message"
    >
      <div>
        <Trans
          i18nKey="loginPage.form.requestErrors.somethingWrongWithoutStatus"
          values={{ email: t("aboutCompany.support.email") }}
          components={{
            supportEmailLink: (
              <MuiLink
                href={`mailto:${t("aboutCompany.support.email")}`}
                underline="hover"
              />
            ),
          }}
        />
      </div>
      {error?.message && <div>{error.message}</div>}
    </Banner>
  );
};
